import React, { useState } from "react";
import StepIndicator from "./StepIndicator";
import { useNavigate } from "react-router-dom";
import api from "../../API/api";

interface FormData {
  usuarioEmail: string;
  senha: string;
  confirmarSenha: string;
}

interface CadastroFormProps {
  token: string;
}

export default function CadastroForm({ token }: CadastroFormProps) {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState<FormData>({
    usuarioEmail: "",
    senha: "",
    confirmarSenha: "",
  });

  const [errors, setErrors] = useState<Partial<FormData>>({});

  // Função genérica de alteração de campo
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({
      ...errors,
      [name]: validateField(name as keyof FormData, value),
    });
  };

  // Validação
  const validateField = (name: keyof FormData, value: string): string => {
    switch (name) {
      case "usuarioEmail":
        return /\S+@\S+\.\S+/.test(value) ? "" : "E-mail inválido";
      case "senha":
      case "confirmarSenha":
        return value.length >= 9
          ? ""
          : "Senha deve ter pelo menos 9 caracteres";
      default:
        return value.trim() ? "" : "Campo obrigatório";
    }
  };

  // ▶ ETAPA 1 — Validar e-mail
  const handleNext = async () => {
    const emailError = validateField("usuarioEmail", formData.usuarioEmail);

    if (emailError) {
      setErrors({ usuarioEmail: emailError });
      return;
    }

    try {

      setStep(2); // sucesso → próxima etapa
    } catch (error: any) {
      const msg =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        "Erro ao validar email";

      setErrors({ usuarioEmail: msg });
    }
  };

  const handleBack = () => setStep(step - 1);

  // ▶ ETAPA 2 — Definir senha (API CORRETA)
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const finalErrors: Partial<FormData> = {};

    ["senha", "confirmarSenha"].forEach((field) => {
      const error = validateField(
        field as keyof FormData,
        formData[field as keyof FormData]
      );
      if (error) finalErrors[field as keyof FormData] = error;
    });

    if (formData.senha !== formData.confirmarSenha) {
      finalErrors.confirmarSenha = "Senhas não conferem";
    }

    setErrors(finalErrors);
    if (Object.keys(finalErrors).length > 0) return;

    try {
      // API CORRETA
      await api.post("/users/setup-password/", {
        token,
        email: formData.usuarioEmail,
        password: formData.senha,
      });

      navigate("/login"); // sucesso → login
    } catch (error: any) {
      const msg =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        "Erro ao definir senha";

      setErrors({ confirmarSenha: msg });
    }
  };

  return (
    <form className="cadastro-form" onSubmit={handleSubmit}>
      <StepIndicator totalSteps={2} currentStep={step} />

      <div className="form-inner">
        {/* ETAPA 1 */}
        {step === 1 && (
          <>
            <h2 className="form-title">Etapa 1 - Cadastro do e-mail</h2>

            <div className="form-group">
              <label>E-mail</label>
              <input
                name="usuarioEmail"
                placeholder="Digite seu e-mail"
                value={formData.usuarioEmail}
                onChange={handleChange}
              />
              {errors.usuarioEmail && (
                <span className="error">{errors.usuarioEmail}</span>
              )}
            </div>

            <div className="button-group">
              <button
                type="button"
                onClick={handleNext}
                className="cadastro-button"
              >
                Próxima etapa
              </button>
            </div>
          </>
        )}

        {/* ETAPA 2 */}
        {step === 2 && (
          <>
            <h2 className="form-title">Etapa 2 - Cadastro da senha</h2>

            <div className="form-group">
              <label>Senha</label>
              <input
                type="password"
                name="senha"
                placeholder="Digite sua senha"
                value={formData.senha}
                onChange={handleChange}
              />
              {errors.senha && <span className="error">{errors.senha}</span>}
            </div>

            <div className="form-group">
              <label>Confirmar senha</label>
              <input
                type="password"
                name="confirmarSenha"
                placeholder="Confirme sua senha"
                value={formData.confirmarSenha}
                onChange={handleChange}
              />
              {errors.confirmarSenha && (
                <span className="error">{errors.confirmarSenha}</span>
              )}
            </div>

            <div className="button-group">
              <button
                type="button"
                onClick={handleBack}
                className="cadastro-button secondary"
              >
                Voltar
              </button>

              <button type="submit" className="cadastro-button">
                Finalizar cadastro
              </button>
            </div>
          </>
        )}
      </div>
    </form>
  );
}
